import React, { useContext } from 'react';

import { ReactComponent as SaveCollectionIcon} from "static/icons/save-collection.svg";

import UniversalButton from "../uiComponents/UniversalButton";
import SaveCollectionModal from "../modals/SaveCollectionModal";
import {ModalContext} from "../ModalContext";

const SaveCollection = ({tableInfo}) => {

  const { handleModal } = useContext(ModalContext);

  const openModal = () => {
    handleModal(
      <SaveCollectionModal closeCollectionModal={closeModal} tableInfo={tableInfo}/>
    );
  }

  const closeModal = () => {
    handleModal(null, true);
  }

  return (
    <>
      <UniversalButton
        style={{height: '32px'}}
        label="Save selection set"
        size="md"
        labelColor="blue"
        labelHoverColor="blue"
        backgroundColor="blue"
        backgroundHoverColor="$blue"
        leftIcon={<SaveCollectionIcon />}
        onClick={openModal}
        isRounded="sm"
      />
    </>
  );
};

export default SaveCollection;